module.exports = __webpack_public_path__ + "img/container2LogoL.dda266e0.png";